import { useMediaQuery } from './useMediaQuery';

/** The reduced-motion media query — shared by the reactive hook and the one-shot read. */
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Whether the user has asked the OS to reduce motion. The single source of truth
 * for every motion branch (simulation timers, GSAP tweens, the glow loop), so the
 * stack can't get out of sync. SSR-safe + synchronous first paint via
 * {@link useMediaQuery}.
 */
export const useReducedMotion = (): boolean => useMediaQuery(REDUCED_MOTION_QUERY);

/**
 * One-shot, NON-reactive read of the reduced-motion preference, for imperative branches
 * (effects / RAF / GSAP setup) that only need the value once at run time and can't consume
 * a hook. SSR-safe (`window.matchMedia` may be absent). Use {@link useReducedMotion} when
 * the component should re-render as the OS preference changes.
 */
export const prefersReducedMotion = (): boolean => window.matchMedia?.(REDUCED_MOTION_QUERY).matches ?? false;

export default useReducedMotion;
